export default __webpack_public_path__ + "static/media/Pause.a705fd0d.svg";